import script from "./AuthLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthLayout.vue?vue&type=script&setup=true&lang=js"

import "./AuthLayout.vue?vue&type=style&index=0&id=66950b39&scoped=true&lang=css"

import exportComponent from "/var/www/html/tds/tds-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66950b39"]])

export default __exports__